import { Entity, Field } from 'typegraph';

import { ID } from 'common/entities/IEntity';
import LaunchURL from "./LaunchUrl";

@Entity({one: "entry", many: "entries"})
export default class Entry {

	@Field()
	public id: ID;

	@Field()
	public startDate: string;

	@Field()
	public endDate: string;

	@Field()
	public displayName: string;

}



// WEBPACK FOOTER //
// ./src/panels/subscriptions/entities/Entry.ts